import React, { useImperativeHandle, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { useI18n } from 'i18n';
import { cx } from 'core/api';
import { actions } from 'core/redux/api/reports';
import Form from 'core/react/general/form/Form';
import ObjectDeviceManager from 'core/react/share/devices/ObjectDeviceManager';
import { localStorage as storage } from 'core/app/storage';
import DummyControl from 'core/react/general/form/DummyControl';
import GroupingPicker from 'core/react/share/categories/GroupingPicker';

import './parametrizator.scss';

export default connect((state) => ({
	state: state.reports.deviceUtilization,
}))((props) => {
	const { f } = useI18n();
	const dispatch = useDispatch();

	const [isAssetTypes, setIsAssetTypes] = useState(false);
	const [isGrouping, setGrouping] = useState(false);
	const [groupingId, setGroupingId] = useState(storage.get('groupingId'));

	useImperativeHandle(props.customRef, () => ({
		submit: (values) => {
			const parameters = new cx.ods.reports.UtilizationReportParameters();
			parameters.timeRange = new cx.ods.TimeRange({ since: props.timeRange.since, until: props.timeRange.until });
			if (0 < values.uris?.length) parameters.uris = values.uris;
			parameters.groupingId = isGrouping ? groupingId : null;
			parameters.isAssetTypes = isAssetTypes;
			dispatch(actions.deviceUtilization.generate.request({ parameters }));
		},
		clear: () => {
			dispatch(actions.deviceUtilization.export.clear());
		},
	}));

	const {
		disabled,
		state: { parameters },
	} = props;
	return (
		<div className="device-utilization-parameters">
			<ObjectDeviceManager
				controlName="uris"
				title={f('devices restriction')}
				disabled={disabled}
				emptyMessage={f('all devices')}
				editMode
				uris={parameters?.uris}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isGrouping"
				value={isGrouping}
				onChange={setGrouping}
				label={f('include device grouping')}
				disabled={props.disabled}
			/>
			<Form.Control controlType={DummyControl} controlName="grouping" value={groupingId} onChange={() => {}} hidden />
			<GroupingPicker
				disabled={props.disabled || !isGrouping}
				categoryId={groupingId}
				onChange={setGroupingId}
				cleanable={false}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isAssetTypes"
				value={isAssetTypes}
				onChange={setIsAssetTypes}
				label={f('include asset types')}
				disabled={props.disabled}
			/>
		</div>
	);
});
